import { isArray } from 'lodash';

export const isOtpNumeric = (otpArray) => {
  if (otpArray === []) return true;
  if (!isArray(otpArray)) return false;

  return otpArray.every((otpItem) => !isNaN(otpItem) || otpItem === undefined);
};
